<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip top content-class="custom-top-tooltip">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            :disabled="loading"
            class="ml-2 custom-bold-button"
            color="cyan white--text"
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
          >
            {{ entity?.name || "Select Entity" }}
          </v-btn>
        </template>
        <span>Entity</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in entityList"
        :key="index"
        link
        v-on:click="selectEntity(item)"
      >
        <v-list-item-title class="font-weight-600">
          {{ item.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "EntityMenu",

  props: {
    entity: {
      type: Object,
      required: false,
      default: null,
    },
    entityList: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    entityList: {
      immediate: true,
      handler(list) {
        let entityId = this.lodash.toSafeInteger(this.$route?.query?.entity);

        if (entityId > 0 && list?.length) {
          const found = list.find((e) => e.id == entityId);
          if (found) {
            this.$emit("change", found);
          }
        }
      },
    },
  },
  methods: {
    selectEntity(item) {
      this.$emit("change", item);
    },
  },
  mounted() {
    let entityId = this.lodash.toSafeInteger(this.$route?.query?.entity);

    if (entityId > 0) {
      const found = this.entityList?.find((e) => e.id == entityId);
      if (found) {
        this.$emit("change", found);
      }
    }
  },
};
</script>
